import { colors } from "../../theme/colors"

export const InputTitle = {
  marginBottom: "18px",
  marginTop: "24px",
}

export const Input = {
  marginBottom: "16px",
}

export const DateInput = (error?: boolean) => ({
  ...Input,
  "& .MuiFilledInput-underline": {
    "&::before": {
      borderBottom: "none !important",
    },
    "&::after": {
      borderBottom: "none !important",
    },
  },
  "& .MuiInputBase-root": {
    background: colors.lightGrey,
    borderRadius: "10px",
    border: "2px solid transparent",
    transition: "border-color 0.2s",
    ...(error && {
      borderColor: colors.red,
    }),
  },
  "& input": {
    padding: "14px 18px",
    fontSize: 16,
    letterSpacing: 0,
  },
})
